// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file giftcard_product.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file giftcard_product.proto.
 */
export const file_giftcard_product: GenFile = /*@__PURE__*/
  fileDesc("ChZnaWZ0Y2FyZF9wcm9kdWN0LnByb3RvEgtncnBjLmFwaS52MSLwAgoPR2lmdGNhcmRQcm9kdWN0EgoKAmlkGAEgASgDEgwKBGNvZGUYAiABKAkSDQoFdGl0bGUYAyABKAkSEwoLZGVzY3JpcHRpb24YBCABKAkSHAoUYmFja2dyb3VuZF9pbWFnZV91cmwYBSABKAkSEgoKc2VydmljZV9pZBgGIAEoAxIOCgZsb2NhbGUYByABKAkSEQoJaXNfYWN0aXZlGAggASgIEg0KBWNvbG9yGAkgASgJEh8KF2V4cGlyZV9wZXJpb2RfaW5fbW9udGhzGAogASgFEhEKCXNob3dfbG9nbxgLIAEoCBITCgtmb290ZXJfdGV4dBgMIAEoCRIOCgZwcmljZXMYDSADKAMSDAoEZmVlcxgOIAMoAxIQCghjdXJyZW5jeRgPIAEoCRIiChpwYXltZW50X2FjY291bnRfY29uZmlndXJlZBgQIAEoCBIeChZwYXltZW50X2FjY291bnRfYWN0aXZlGBEgASgIQgZaBC47cGJiBnByb3RvMw");

/**
 * GiftcardProduct
 *
 * @generated from message grpc.api.v1.GiftcardProduct
 */
export type GiftcardProduct = Message<"grpc.api.v1.GiftcardProduct"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string background_image_url = 5;
   */
  backgroundImageUrl: string;

  /**
   * @generated from field: int64 service_id = 6;
   */
  serviceId: bigint;

  /**
   * @generated from field: string locale = 7;
   */
  locale: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * @generated from field: string color = 9;
   */
  color: string;

  /**
   * @generated from field: int32 expire_period_in_months = 10;
   */
  expirePeriodInMonths: number;

  /**
   * @generated from field: bool show_logo = 11;
   */
  showLogo: boolean;

  /**
   * @generated from field: string footer_text = 12;
   */
  footerText: string;

  /**
   * @generated from field: repeated int64 prices = 13;
   */
  prices: bigint[];

  /**
   * @generated from field: repeated int64 fees = 14;
   */
  fees: bigint[];

  /**
   * @generated from field: string currency = 15;
   */
  currency: string;

  /**
   * @generated from field: bool payment_account_configured = 16;
   */
  paymentAccountConfigured: boolean;

  /**
   * @generated from field: bool payment_account_active = 17;
   */
  paymentAccountActive: boolean;
};

/**
 * Describes the message grpc.api.v1.GiftcardProduct.
 * Use `create(GiftcardProductSchema)` to create a new message.
 */
export const GiftcardProductSchema: GenMessage<GiftcardProduct> = /*@__PURE__*/
  messageDesc(file_giftcard_product, 0);

